import config from "../config";

import { fetchWithRetry } from ".";
import { auth } from "../firebase/firebase";

export async function createOrganization({
  name,
  descriptiveName,
  description,
}) {
  const token = auth.currentUser?.accessToken;
  const url = `${config.coreApi.protocol}://${config.coreApi.host}/organizations`;
  const response = await fetchWithRetry(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name, descriptiveName, description }),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
}
